export default __webpack_public_path__ + "static/media/financing_cash.f0df09ef.svg";